import React from 'react';
import { loadState, saveState, deleteState } from '../../utilities/localStorage';
import { enquireScreen } from 'enquire-js';
import { injectIntl } from 'react-intl';
import { initializeSocket } from '../../middleware/sockets';
import jwtDecode from 'jwt-decode';
import { Modal, Drawer } from 'antd';
import { createContextualCan } from '@casl/react';
import { Ability } from '@casl/ability';
// import { unpackRules } from '@casl/ability/extra'
import debounce from 'lodash.debounce';
// import SocketHandlers from '../../middleware/socket_handlers';
import { calculateOperatingPeriod } from '../../utilities/dateUtils';
import moment from 'moment';

export const GlobalConfigContext = React.createContext();
export const GlobalConfigConsumer = GlobalConfigContext.Consumer;

export const AbilityContext = React.createContext();
export const Can = createContextualCan(AbilityContext.Consumer);

const ability = new Ability();

let isMobile = false;
enquireScreen((b) => {
	isMobile = !!b;
});
let isTablet = false;
enquireScreen((c) => {
	isTablet = !!c;
}, "only screen and (min-width: 768px) and (max-width:1199px)");

const breakpoints = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600,
}

//this.performSearch = debounce(this.performSearch, 500);

class GlobalConfigProvider extends React.PureComponent {
    constructor(props) {
        super(props);
        const settings = loadState();
        this.activeProperty = null//localStorage.activeProperty ? JSON.parse(localStorage.activeProperty) : null;
        const propertySettings = this.activeProperty && this.activeProperty.settings
        const token = localStorage.authToken || null;
        const rules_token = true;//localStorage.rulesToken || null;
        //const packedRules = rules_token ? jwtDecode(rules_token) : null;
        const rules = [{action: 'manage', subject: 'all'}];//(rules_token && packedRules && packedRules.rules.length) ? unpackRules(packedRules.rules) : [];

        const user  = token ? jwtDecode(token) : null
        // console.log('user', user)

		const socket = initializeSocket();
        this.state = {
            ability: new Ability(rules),
            intl:props.intl,
            theme: settings && settings.theme ? settings.theme : "light",
			toggleTheme: this.toggleTheme,
            sider_position: (settings && settings.sider_position)?settings.sider_position:'side',
            changeSiderPosition: this.changeSiderPosition,
            sticky_top: true,
            isMobile: isMobile,
            isTablet: isTablet,
            breakpoint: '',
            size: 'default',
            socket: socket || null,
            socketConnected: true,//socket ? true : false,
            offline: false,
            currencyCode: (this.activeProperty && this.activeProperty.currency) || 'EUR',
            dateFormat: 'DD/MM/YYYY',
	  		dateFullFormat: 'ddd D MMM YYYY',
            dateTimeFormat: 'DD/MM/YYYY H:mm',
            activeProperty: this.activeProperty,
            setActiveProperty: this.setActiveProperty,
            // user: token ? jwtDecode(token) : null,
            user: (user && user.user) ? user.user : null,
            properties: (localStorage.properties !== undefined) ? JSON.parse(localStorage.properties) : [],
            isAuthenticated: (token && rules_token) ? true : false,
            language: (settings && settings.language) || 'en-gb',
			locale: (settings && settings.locale) || 'en-GB',
            timezone: (settings && settings.timezone) || 'Europe/Athens',
            handleLoggedin: this.handleLoggedin,
            handleLogout: this.handleLogout,
            notifications: props.notifications,
            upperCaseFormFields: settings && settings.upperCaseFormFields ?settings.upperCaseFormFields:false,
            updateGlobalSetting: this.updateGlobalSetting,
            updateViewSetting: this.updateViewSetting,
            view_settings: settings && settings.view_settings ? settings.view_settings : {},
            settings: propertySettings ? propertySettings : {},
            showModal: this.showModal,
            closeModal: this.closeModal,
            modal: {
                props:{
                    title: '',
                    visible: false,
                    closable:true,
                    maskClosable: true,
                    destroyOnClose: true,
                    width: 700,
                    wrapClassName: "ant-confirm ant-confirm-form modal-without-padding",
                    onCancel:this.closeModal
		            //onClick: this.handleCloseModal
                },
                content: ''
            },
            useDrawers: true,
            visibleDrawer: false,
            showDrawer: this.showDrawer,
            closeDrawer: this.closeDrawer,
            defaultDateParams: settings && settings.defaultDateParams ? settings.defaultDateParams : (this.activeProperty && this.activeProperty.operation_type === 'seasonal' ? calculateOperatingPeriod({}, this.activeProperty) : {
                fromd: moment().startOf('year').format('YYYY-MM-DD'),
                tod: moment().endOf('year').format('YYYY-MM-DD'),
            })
        };

        // IF activeProperty !== null THEN CONNECT SOCKET
	  	//if(props.activeProperty && props.activeProperty.id !== null){
            //socketsJoinProperty(props.activeProperty.id, this.props.socketActions);
        //}
        window.addEventListener('storage', e => {
            // Switch property on all tabs
            if(e.key === 'activeProperty') {
                const oldValue = JSON.parse(e.oldValue);
                const newValue = JSON.parse(e.newValue);
                //console.log(`oldValue:newValue:`, oldValue, newValue);
                if(oldValue && oldValue.id && newValue && newValue.id && oldValue.id !== newValue.id){
                    //console.log(`setActiveProperty:`, newValue);
                    this.setActiveProperty(newValue);
                    window.location.reload();
                }
            }
        });
    }
    
    // componentWillMount(){
    //     //this.initializeSockets();
    // }
    componentDidMount = () => {
        //console.log(`componentDidMount:GlobalConfigProvider`);
        
        //if(this.activeProperty && this.activeProperty.id !== null){
            //console.log(`activeProperty:`, activeProperty);
            //this.socketsJoinProperty();
        //}
        this.initializeSockets();
        enquireScreen((b) => {
            //console.log(`b`, b);
            this.setState({
                isMobile: !!b,
            });
        });

        enquireScreen((c) => {
            //console.log(`c`, c);
            this.setState({
                isTablet: !!c,
            });
        }, "only screen and (min-width: 768px) and (max-width:1199px)");

        const debouncedResize = debounce(this.handleResize, 50);
        window.addEventListener('resize', debouncedResize, { passive: true });
        this.handleResize();
    }
    componentDidUpdate = (prevProps, prevState) => {
        if(!this.state.socket){
            this.setState({
                socket: initializeSocket()
            });
        }else if((this.state.user !== prevState.user && this.state.user && this.state.socket) || (prevState.socket !== this.state.socket && this.state.socket && this.state.user) ){
            //console.log(`componentDidUpdate: `, 'initializeSockets')
            this.initializeSockets();
        }
        //console.log(`componentDidUpdate prevState:`, this.state.isAuthenticated, prevState.isAuthenticated)
    }
    componentWillUnmount() {
        //window.removeEventListener('resize', this.handleResize);
    }
    handleResize = () => {
        const clientWidth = window.innerWidth;
        //const { breakpoints } = this.props;
        if (clientWidth >= breakpoints.xxl) {
            this.setState({
                breakpoint: 'xxl',
                size: 'large'
            });
        }else if (clientWidth >= breakpoints.xl) {
            this.setState({
                breakpoint: 'xl',
                size: 'default'
            }); 
        } else if (clientWidth >= breakpoints.lg) {
            this.setState({
                breakpoint: 'lg',
                size: 'default'
            });
        } else if (clientWidth >= breakpoints.md) {
            this.setState({
                breakpoint: 'md',
                size: 'default'
            });
        } else if (clientWidth >= breakpoints.sm) {
            this.setState({
                breakpoint: 'sm',
                size: 'default'
            });
        } else if (clientWidth < breakpoints.sm) {
            this.setState({
                breakpoint: 'xs',
                size: 'default'
            });
        }
    }
    toggleTheme = checked => {
        const theme = checked ? "light" : "dark";
        this.setState({ theme: theme });
        saveState({ theme: theme });

        document.documentElement.classList.add('theme-transition');
		document.documentElement.setAttribute('data-theme', theme);
		window.setTimeout(function() {
			document.documentElement.classList.remove('theme-transition');
		}, 1000);
	};
    changeSiderPosition = evt => {
        this.setState({ sider_position: evt.target.value ? evt.target.value : "top" });
        saveState({ sider_position: evt.target.value ? evt.target.value : "top" });
    };
    updateViewSetting = setting => {
        //console.log(`setting:`, setting, this.state.view_settings)
        this.setState((prevState) => {
            const view_settings = prevState.view_settings ? Object.assign(prevState.view_settings, setting) : setting
            //console.log(`view_settings:`, view_settings)
            saveState({ view_settings });
            return {
                view_settings
            };
        });
    };
    updateGlobalSetting = setting => {
        this.setState(setting);
        saveState(setting);
    };
    initializeSockets = (newSocket) => {
        //console.log('initializeSockets');
        //initializeSocket();

        // this.setState({
        //     socket
        // });

        const socket = newSocket ? newSocket : this.state.socket;
        //console.log(`socket:`, socket)
        
        if(socket){
            socket.on('connect', () => {
                //console.log('connected');
                //socketActions.connect();
                //console.log(`connect socket:`, socket.id)
                localStorage.socket_id = socket.id;
                
                this.socketsJoinProperty();
                //this.socketsUserConnect();
                

                this.setState({
                    socketConnected: true,
                    offline: false,
                });
            });
            
            socket.on('disconnect', () => {
                //console.log('Disconnect from server');
                //socketActions.disconnect();
                /*if(this.activeProperty && this.activeProperty.id !== null){
                    this.socketsLeaveProperty(this.activeProperty.id);
                }*/
                localStorage.socket_id = null;
                this.setState({
                    socketConnected: false,
                    offline: false,
                });
            });
            
            socket.on('error', (err) => {
                //console.log('Error connecting to server', err);
                /*if(this.activeProperty && this.activeProperty.id !== null){
                    this.socketsLeaveProperty(this.activeProperty.id);
                }*/
                //socketActions.disconnect();
                localStorage.socket_id = null;
                this.setState({
                    socketConnected: false,
                    offline: false,
                });
            });
            
            socket.on('reconnect', (number) => {
                //console.log('Reconnected to server', number);
                /*if(this.activeProperty && this.activeProperty.id !== null){
                    this.socketsJoinProperty(this.activeProperty.id);
                }*/
            });
            
            socket.on('reconnect_attempt', () => {
                //console.log('Reconnect Attempt');
            });
            
            socket.on('reconnecting', (number) => {
                //console.log('Reconnecting to server', number);
            });
            
            socket.on('reconnect_error', (err) => {
                //console.log('Reconnect Error', err);
                //socketActions.disconnect();
                /*if(this.activeProperty && this.activeProperty.id !== null){
                    this.socketsLeaveProperty(this.activeProperty.id);
                }*/
                this.setState({
                    socketConnected: false,
                    offline: false,
                });
            });
            
            socket.on('reconnect_failed', () => {
                //console.log('Reconnect failed');
                //socketActions.disconnect();
                /*if(this.activeProperty && this.activeProperty.id !== null){
                    this.socketsLeaveProperty(this.activeProperty.id);
                }*/
                this.setState({
                    socketConnected: false,
                    offline: false,
                });
            });
            
            socket.on('connect_error', () => {
                //console.log('connect_error');
                //socketActions.disconnect();
                /*if(this.activeProperty && this.activeProperty.id !== null){
                    this.socketsLeaveProperty(this.activeProperty.id);
                }*/
                this.setState({
                    socketConnected: false,
                    offline: false
                });
            });
        }
    }
    socketsJoinProperty = (property_id) => {
        const property = property_id?property_id:(localStorage.activeProperty ? JSON.parse(localStorage.activeProperty).id : null);
        const { socket, user } = this.state;
        if(property && socket){
            //console.log('socketsJoinProperty', property);
            // if(!socket){
            //     this.initializeSockets();
            // }
            socket.emit('subscribeToProperty', property);
            if(user && user.id){
                if(socket){
                    socket.emit('userConnect', user.id, property);
                }
            }
        }
    }
    socketsLeaveProperty = (property_id) => {
        const property = property_id?property_id:(localStorage.activeProperty ? JSON.parse(localStorage.activeProperty).id : null);
        //console.log(`socketsLeaveProperty property:`, property)
        const { socket, user } = this.state;
        if(property && socket){
            if(socket){
                socket.emit('unsubscribeFromProperty', property);
                if(user && user.id){
                    socket.emit('userLeave', user.id, property);
                }
                //socket = null;
            }
        }
    }
    socketsUserConnect = (user_id) => {
        const { socket, user } = this.state;
        if(user && user.id){
            if(socket){
                socket.emit('userConnect', user.id);
            }
        }
    }
    socketsUserLeave = (user_id) => {
        //const user = user_id?user_id:(localStorage.activeProperty ? JSON.parse(localStorage.activeProperty).user_id : null);
        const { socket, user } = this.state;
        if(user && user.id){
            //console.log('socketsUserLeave', user);
            if(socket){
                socket.emit('userLeave', user.id);
                //socket = null;
            }
        }
    }
    getActiveProperty = (properties) => {
		const newproperties = properties;
		//const profile = jwtDecode(token);
		localStorage.properties = JSON.stringify(newproperties);
		const property = newproperties[0];
		localStorage.activeProperty = JSON.stringify(property);
		//console.log('getActiveProperty', property);
		return property;
	}
    handleLoggedin = (response) => {
        //console.log(`response:`, response)
		//const properties = response.properties;
    	//console.log(`properties:`, properties);
    	const settings = response.settings;
    	//console.log(`settings:`, settings)
    	//const token = response.token;
    	//const activeProperty = this.getActiveProperty(properties);
    	//const activeProperty = getActiveProperty(token);
        //saveState(settings);
        // if(!this.state.socket){
        //     const socket = initializeSocket();
        //     this.setState({
        //         socket
        //     });
        //     this.initializeSockets(socket);
        // }else{
        //     this.initializeSockets();
        // }

        const socket = initializeSocket(response.token);

        //this.initializeSockets();
        
        //const packedRules = jwtDecode(response.rules_token);
        //console.log(`packedRules:`, packedRules);
        // const rules = response.rules_token ? unpackRules(jwtDecode(response.rules_token).rules) : [];
        const rules = [{action: 'manage', subject: 'all'}];
        //console.log(`rules:`, rules);
        //this.socketsJoinProperty(response.activeProperty.id);
        if(!rules || !rules.length /*|| !localStorage.rulesToken*/){
            this.handleLogout({
                user: response.user,
			    activeProperty: response.activeProperty,
            });
        }
        ability.update(rules || []);
		
		this.setState({
            ability,
			isAuthenticated: true,
			user: response.user,
			activeProperty: response.activeProperty,
			properties: response.properties,
			errorMessage: null,
			language:response.language,
			locale:response.locale_id,
            isSetup: false,//(activeProperty.setup_completed !== undefined) ? !Boolean(activeProperty.setup_completed) : true,
            socket,
            view_settings: settings && settings.view_settings? settings.view_settings : {},
            upperCaseFormFields: settings && settings.upperCaseFormFields ? settings.upperCaseFormFields : false,
            //language: (settings && settings.language) || null,
            //locale: (settings && settings.locale) || null,
            timezone: (settings && settings.timezone) || null,
            sider_position: (settings && settings.sider_position)?settings.sider_position:'side',
            theme: settings && settings.theme ? settings.theme : "light",
		});
		saveState({
			language: response.language,
			locale:response.user.locale_id
		}, true);
    }
    handleLogout = (params) => {
        //console.log(`handleLogout:`, params)
        if(params && params.activeProperty && params.activeProperty.id){
            this.socketsLeaveProperty(params.activeProperty.id);
        }
        //this.socketsUserLeave(params.user.id);
        // if(params){
        //     if(params.activeProperty){
        //         this.state.socket.emit('unsubscribeFromProperty', params.activeProperty.id);
        //     }
        //     // if(params.user){
        //     //     console.log(`params.user:`, params.user)
        //     //     this.state.socket.emit('userLeave', params.user.id);
        //     // }
        // }
        //console.log(`handleLogout:`);
        deleteState();
        localStorage.removeItem("authToken");
        localStorage.removeItem("rulesToken");
        localStorage.removeItem("activeProperty");
        this.setState({
            isAuthenticated: false,
            user: null,
            activeProperty: null,
            properties: [],
            socket: null
        });
        ability.update([]); // removes all rules
    }
    setActiveProperty = (property) => {
        // console.log(`setActiveProperty:`,property )
        localStorage.activeProperty = JSON.stringify(property);
        this.setState((prevState) => {
            this.socketsLeaveProperty(prevState.activeProperty.id);
            //this.socketsJoinProperty(property.id);
            return {
                activeProperty: property,
                currencyCode: (property && property.currency) || 'EUR',
                settings: (property && property.settings) || {},
                socket: initializeSocket()
            };
        });
        // this.socketsJoinProperty(property.id);
    }
    updateCalendarCellWidth = (width) => {
        //console.log(`width:`, width);
        if(width){
            this.setState({
                calendar_cell_width: width
            });
            saveState({ calendar_cell_width: width });
        }
	}
	updateCalendarDays = (days) => {
		//console.log(`global updateCalendarDays:`, days);
		if (days) {
			this.setState({
				calendar_days: days
			});
			saveState({ calendar_days: days });
		}
	}
    showModal = (modalProps) => {
        this.setState((prevState) => {
            return {
                modal: {
                    props: Object.assign(prevState.modal.props, modalProps.props),
                    content: modalProps.content
                },
            };
        });
    }
    closeModal = (event) => {
        if(event && event.stopPropagation){
            event.preventDefault();
            event.stopPropagation();
        }
        this.setState((prevState) => {
            return {
                modal: {
                    props: Object.assign(prevState.modal.props, { visible: false }),
                    content: ''
                },
            };
        });
    }
    showDrawer = () => {
        this.setState({ visibleDrawer: true });
    }
    closeDrawer = () => {
        this.setState({ visibleDrawer: false });
    }
    render() {
        //console.log(`render context :`);
        return (
            <GlobalConfigContext.Provider value={this.state}>
                <AbilityContext.Provider value={ability}>
                    {/* <SocketHandlers /> */}
                    <Modal
                        //onCancel={this.closeModal}
                        {...this.state.modal.props}
                        //onOk={this.handleSubmit}
                            
                        //onClick={this.closeModal}
                        //   footer={!this.state.modal.footer?[
                        //  	  <Button key="back" onClick={this.closeModal}><FormattedMessage id="reservations.reservation-room-actions.cancel" defaultMessage={`Cancel`} /></Button>,
                        //  	  <Button key="submit" type={okType} onClick={okFn} autoFocus >{okText}</Button>,
                        //   ]:false}
                        >
                        {this.state.modal.content}
                    </Modal>
                    <Drawer
                        title="Basic Drawer"
                        placement="right"
                        onClose={this.closeDrawer}
                        visible={this.state.visibleDrawer}
                        //getContainer={false}
                        // style={{ position: 'absolute' }}
                    >
                        <p>Some contents...</p>
                    </Drawer>
                {this.props.children}
                </AbilityContext.Provider>
            </GlobalConfigContext.Provider>
        );
    }
}

export default injectIntl(GlobalConfigProvider, { withRef: true });